import algoliasearch from 'algoliasearch';

export const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID || '',
  process.env.REACT_APP_ALGOLIA_API_KEY_SEARCH || '',
);

export const projectEventsIndex = searchClient.initIndex('projectEvents');
